import { useTranslation } from 'react-i18next';

/**
 * Generic skeleton fallback used for lazy-loaded route chunks.
 * Honors prefers-reduced-motion via Tailwind's animate-pulse default.
 */
export function RouteFallback() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="flex min-h-[40vh] flex-col items-center justify-center gap-4 p-8"
    >
      <div className="h-2 w-48 animate-pulse rounded bg-slate-200 motion-reduce:animate-none" />
      <div className="h-2 w-32 animate-pulse rounded bg-slate-200 motion-reduce:animate-none" />
      <span className="sr-only">{t('common.loading', 'Loading…')}</span>
    </div>
  );
}
